"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _next2 = require("@alifd/next");
var _get2 = _interopRequireDefault(require("loadsh/get"));
var _QRCode = _interopRequireDefault(require("./components/QRCode"));
var _authorization = require("./services/gov-form-runtime/authorization");
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
var _CommonLayout = _interopRequireDefault(require("./components/CommonLayout"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function CommissionContext(props) {
  var _window$G_GOV_MESSAGE, _window$G_GOV_MESSAGE2, _window$G_GOV_MESSAGE3, _window$G_GOV_MESSAGE4;
  var onCancel = props.onCancel,
    isQuick = props.isQuick,
    _props$defaultStep = props.defaultStep,
    defaultStep = _props$defaultStep === void 0 ? '0' : _props$defaultStep,
    _props$_form_ability_ = props._form_ability_authorization_resultUsingGet,
    _form_ability_authorization_resultUsingGet = _props$_form_ability_ === void 0 ? _authorization._form_ability_authorization_resultUsingGet : _props$_form_ability_,
    _props$_form_ability_2 = props._form_ability_authorization_initializeUsingPost,
    _form_ability_authorization_initializeUsingPost = _props$_form_ability_2 === void 0 ? _authorization._form_ability_authorization_initializeUsingPost : _props$_form_ability_2,
    request = props.request;
  //如果业务方把request当作属性传入 那么就在services文件夹下的请求中使用业务发提供的request
  if (request) {
    window.request = request;
  }
  var _get = (0, _get2["default"])(props, 'store', {}),
    _get$authorizer = _get.authorizer,
    authorizer = _get$authorizer === void 0 ? {} : _get$authorizer,
    bizNo = _get.bizNo,
    bizScene = _get.bizScene,
    bizParam = _get.bizParam;
  var _useState = (0, _react.useState)({
      successInfo: '',
      failedInfo: '',
      waitingInfo: ''
    }),
    _useState2 = _slicedToArray(_useState, 2),
    messageInfo = _useState2[0],
    setMessageInfo = _useState2[1];
  var onSubmit = (0, _get2["default"])(props, 'action.onSubmit');
  var onFail = (0, _get2["default"])(props, 'action.onFail');
  var FacevalidateQR = (0, _get2["default"])(props, 'component.FacevalidateQR', _QRCode["default"]);
  var GlobalMessage = (0, _get2["default"])(props, 'component.GlobalMessage', function (_ref) {
    var defaultValue = _ref.defaultValue;
    return /*#__PURE__*/_react["default"].createElement("span", null, defaultValue);
  });
  var _useState3 = (0, _react.useState)(defaultStep),
    _useState4 = _slicedToArray(_useState3, 2),
    step = _useState4[0],
    setStep = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    countDown = _useState6[0],
    setCountDown = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    certifyCode = _useState8[0],
    setCertifyCode = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = _slicedToArray(_useState9, 2),
    cipher = _useState10[0],
    setCipher = _useState10[1];
  var _useState11 = (0, _react.useState)(true),
    _useState12 = _slicedToArray(_useState11, 2),
    visible = _useState12[0],
    setVisiable = _useState12[1];
  var _useState13 = (0, _react.useState)(''),
    _useState14 = _slicedToArray(_useState13, 2),
    message = _useState14[0],
    setMessage = _useState14[1];
  var _useState15 = (0, _react.useState)(),
    _useState16 = _slicedToArray(_useState15, 2),
    certifyUrl_ = _useState16[0],
    setCertifyUrl = _useState16[1];
  var timerRef = (0, _react.useRef)();
  var dealTimerRef = (0, _react.useRef)();
  var startTimerRef = (0, _react.useRef)();
  var LOCAL = {
    step0: [{
      title: '面对面授权',
      desc: '若对方此时在你身边，由对方完成人脸验证即授权成功',
      src: (_window$G_GOV_MESSAGE = window.G_GOV_MESSAGE) === null || _window$G_GOV_MESSAGE === void 0 ? void 0 : _window$G_GOV_MESSAGE.faceToFace,
      imgStyle: {
        height: 129,
        width: 171,
        marginTop: 35
      }
    }, {
      title: '远程授权',
      desc: '若对方此时不在你身边，可通过二维码的方式让对方远程授权',
      src: (_window$G_GOV_MESSAGE2 = window.G_GOV_MESSAGE) === null || _window$G_GOV_MESSAGE2 === void 0 ? void 0 : _window$G_GOV_MESSAGE2.access,
      imgStyle: {
        height: 122,
        width: 135,
        marginTop: 43
      }
    }],
    step1: {
      dialogTitle: '面对面授权',
      title: /*#__PURE__*/_react["default"].createElement("div", {
        className: _indexModule["default"].faceTitle
      }, /*#__PURE__*/_react["default"].createElement(_next2.Icon, {
        type: "clock",
        style: {
          color: '#0052FF',
          marginRight: 8,
          height: 28,
          lineHeight: '28px'
        }
      }), "\u7B49\u5F85\u5BF9\u65B9\u5B8C\u6210\u6388\u6743")
    },
    step1_1: {
      dialogTitle: '面对面授权',
      title: /*#__PURE__*/_react["default"].createElement("div", {
        className: _indexModule["default"].faceTitle
      }, /*#__PURE__*/_react["default"].createElement(_next2.Icon, {
        type: "error",
        style: {
          color: '#E51C1C',
          marginRight: 8,
          height: 28,
          lineHeight: '28px'
        }
      }), "\u6388\u6743\u5931\u8D25\uFF0C\u8BF7\u518D\u6B21\u5C1D\u8BD5"),
      desc: /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          textAlign: 'center',
          display: 'block'
        }
      }, " ", message)
    },
    step2: {
      dialogTitle: '远程授权',
      title: /*#__PURE__*/_react["default"].createElement("div", {
        className: _indexModule["default"].faceTitle
      }, /*#__PURE__*/_react["default"].createElement(_next2.Icon, {
        type: "clock",
        style: {
          color: '#0052FF',
          marginRight: 8,
          height: 28,
          lineHeight: '28px'
        }
      }), "\u7B49\u5F85\u5BF9\u65B9\u5B8C\u6210\u6388\u6743"),
      tip1Title: '方法1：对方将收到以下通知',
      tip1Desc: message,
      tip2Title: '方法2:  发送下方二维码给对方',
      tip2Desc: /*#__PURE__*/_react["default"].createElement("text", null, /*#__PURE__*/_react["default"].createElement("span", null, "\u8BF7\u4F7F\u7528", /*#__PURE__*/_react["default"].createElement(GlobalMessage, {
        configKey: "appName",
        defaultValue: "\u529E\u4E8BAPP"
      })), "\u626B\u63CF\u4E0B\u65B9\u4E8C\u7EF4\u7801\u5B8C\u6210\u6388\u6743")
    },
    step2_1: {
      dialogTitle: '远程授权',
      title: '授权成功，请继续办理',
      src: (_window$G_GOV_MESSAGE3 = window.G_GOV_MESSAGE) === null || _window$G_GOV_MESSAGE3 === void 0 ? void 0 : _window$G_GOV_MESSAGE3.helpSuccess,
      desc: message
    },
    step2_2: {
      dialogTitle: '远程授权',
      title: '授权失败，请再次尝试',
      src: (_window$G_GOV_MESSAGE4 = window.G_GOV_MESSAGE) === null || _window$G_GOV_MESSAGE4 === void 0 ? void 0 : _window$G_GOV_MESSAGE4.helpFail,
      desc: message
    }
  };
  (0, _react.useEffect)(function () {
    var change = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(step) {
        var paramObj, data, _certifyCode, expireSeconds, certifyUrl, data2, _certifyCode2, _expireSeconds, _certifyUrl;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              paramObj = bizParam ? JSON.parse(bizParam) : {};
              _context.t0 = step;
              _context.next = _context.t0 === '1' ? 4 : _context.t0 === '1_1' ? 9 : _context.t0 === '2' ? 11 : _context.t0 === '2_1' ? 16 : _context.t0 === '2_2' ? 18 : 20;
              break;
            case 4:
              _context.next = 6;
              return _form_ability_authorization_initializeUsingPost({
                bizNo: bizNo,
                authorizer: authorizer,
                bizParam: bizParam,
                bizScene: bizScene,
                mode: 'FACE_TO_FACE',
                matterId: paramObj === null || paramObj === void 0 ? void 0 : paramObj.matterId
              });
            case 6:
              data = _context.sent;
              if (data.data) {
                _certifyCode = (0, _get2["default"])(data, 'data.certifyCode');
                expireSeconds = (0, _get2["default"])(data, 'data.expireSeconds');
                certifyUrl = (0, _get2["default"])(data, 'data.certifyUrl', undefined);
                setMessageInfo({
                  successInfo: (0, _get2["default"])(data, 'data.successCopy'),
                  failedInfo: (0, _get2["default"])(data, 'data.failedCopy'),
                  waitingInfo: (0, _get2["default"])(data, 'data.notifyCopy')
                });
                setCertifyUrl(certifyUrl);
                setCertifyCode(_certifyCode);
                setCountDown(expireSeconds);
                dealTimerRef.current = expireSeconds;
                startTimerRef.current = new Date().getTime();
                timerRef.current = setInterval(function () {
                  setCountDown(function (preSecond) {
                    if (preSecond <= 1) {
                      setStep('1_1');
                      setMessage('当前的代办授权任务已过期，若需继续申请，请返回重试');
                    } else {
                      _form_ability_authorization_resultUsingGet({
                        bizScene: bizScene,
                        bizNo: bizNo
                      }).then(function (_ref3) {
                        var data = _ref3.data;
                        if (data !== null && data !== void 0 && data.success) {
                          handleOnCancel(undefined);
                          onSubmit({
                            success: true,
                            value: _certifyCode,
                            cipher: (0, _get2["default"])(data, 'cipher')
                          });
                        } else if ((data === null || data === void 0 ? void 0 : data.success) === false) {
                          setStep('1_1');
                          setMessage(messageInfo.failedInfo);
                        }
                      });
                      var remainTime = Math.ceil((new Date().getTime() - startTimerRef.current) / 1000); // 实际上过了多少秒;
                      var overSecond = dealTimerRef.current - preSecond; // 倒计时已经过了多少秒;
                      if (remainTime - overSecond > 2) {
                        // 手机熄屏后，js会不执行 所以需要校验倒计时时间准确性
                        return dealTimerRef.current - remainTime > 0 ? dealTimerRef.current - remainTime : 0;
                      } else {
                        return preSecond - 1;
                      }
                    }
                  });
                }, 1000);
              }
              return _context.abrupt("break", 21);
            case 9:
              clearInterval(timerRef.current);
              return _context.abrupt("break", 21);
            case 11:
              _context.next = 13;
              return _form_ability_authorization_initializeUsingPost({
                bizNo: bizNo,
                authorizer: authorizer,
                bizParam: bizParam,
                bizScene: bizScene,
                mode: 'RMOETE',
                matterId: paramObj === null || paramObj === void 0 ? void 0 : paramObj.matterId
              });
            case 13:
              data2 = _context.sent;
              if (data2.data) {
                setMessageInfo({
                  successInfo: (0, _get2["default"])(data2, 'data.successCopy'),
                  failedInfo: (0, _get2["default"])(data2, 'data.failedCopy'),
                  waitingInfo: (0, _get2["default"])(data2, 'data.notifyCopy')
                });
                _certifyCode2 = (0, _get2["default"])(data2, 'data.certifyCode');
                _expireSeconds = (0, _get2["default"])(data2, 'data.expireSeconds');
                _certifyUrl = (0, _get2["default"])(data2, 'data.certifyUrl');
                setCertifyUrl(_certifyUrl);
                setCertifyCode(_certifyCode2);
                setCountDown(_expireSeconds);
                setMessage(messageInfo.waitingInfo);
                dealTimerRef.current = _expireSeconds;
                startTimerRef.current = new Date().getTime();
                timerRef.current = setInterval(function () {
                  setCountDown(function (preSecond) {
                    if (preSecond <= 1) {
                      setStep('2_2');
                      setMessage('当前的代办授权任务已过期，若需继续申请，请返回重试');
                    } else {
                      _form_ability_authorization_resultUsingGet({
                        bizScene: bizScene,
                        bizNo: bizNo
                      }).then(function (_ref4) {
                        var data = _ref4.data;
                        if (data !== null && data !== void 0 && data.success) {
                          setStep('2_1');
                          setCipher((0, _get2["default"])(data, 'cipher'));
                          setMessage(messageInfo.successInfo);
                        } else if ((data === null || data === void 0 ? void 0 : data.success) === false) {
                          setStep('2_2');
                          setMessage(messageInfo.failedInfo);
                        }
                      });
                      var remainTime = Math.ceil((new Date().getTime() - startTimerRef.current) / 1000); // 实际上过了多少秒;
                      var overSecond = dealTimerRef.current - preSecond; // 倒计时已经过了多少秒;
                      if (remainTime - overSecond > 2) {
                        // 手机熄屏后，js会不执行 所以需要校验倒计时时间准确性
                        return dealTimerRef.current - remainTime > 0 ? dealTimerRef.current - remainTime : 0;
                      } else {
                        return preSecond - 1;
                      }
                    }
                  });
                }, 1000);
              }
              return _context.abrupt("break", 21);
            case 16:
              clearInterval(timerRef.current);
              return _context.abrupt("break", 21);
            case 18:
              clearInterval(timerRef.current);
              return _context.abrupt("break", 21);
            case 20:
              return _context.abrupt("break", 21);
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function change(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    change(step);
    return function () {
      clearInterval(timerRef.current);
    };
  }, [step]);
  var handleOnCancel = function handleOnCancel(event) {
    clearInterval(timerRef.current);
    if (isQuick) {
      setVisiable(false);
    }
    if (step === '2_1') {
      onSubmit({
        success: true,
        value: certifyCode,
        cipher: cipher
      });
    } else {
      onCancel && onCancel(event);
    }
  };
  var showCountDown = function showCountDown(countDown_) {
    if (countDown_) {
      var minutes = Math.floor(countDown_ / 60);
      var minutesStr = minutes === 0 ? '' : "".concat(minutes, "\u5206");
      var second = countDown_ % 60;
      return minutesStr + (second == 0 ? '钟' : "".concat(second, "\u79D2"));
    } else {
      return '';
    }
  };
  var renderContext = function renderContext(step_) {
    var context = null;
    switch (step_) {
      case '0':
        context = /*#__PURE__*/_react["default"].createElement("div", {
          className: _indexModule["default"].stepOne
        }, LOCAL.step0.map(function (_ref5, index) {
          var title = _ref5.title,
            desc = _ref5.desc,
            src = _ref5.src,
            imgStyle = _ref5.imgStyle;
          return /*#__PURE__*/_react["default"].createElement(_CommonLayout["default"], {
            onClick: function onClick() {
              setStep("".concat(index + 1));
            },
            title: title,
            desc: desc,
            style: {
              cursor: 'pointer',
              width: 261,
              height: 262,
              background: '#F2F6FF',
              borderRadius: 10,
              backgroundColor: '#F2F6FF',
              padding: 20,
              paddingBottom: 0
            },
            customArea: /*#__PURE__*/_react["default"].createElement("img", {
              src: src,
              style: imgStyle
            })
          });
        }));
        break;
      case '1':
        context = /*#__PURE__*/_react["default"].createElement(_CommonLayout["default"], {
          title: LOCAL.step1.title,
          desc: /*#__PURE__*/_react["default"].createElement("div", {
            className: _indexModule["default"].faceDesc
          }, "\u8BF7\u5BF9\u65B9\u4F7F\u7528", /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              color: '#0052FF'
            }
          }, /*#__PURE__*/_react["default"].createElement(GlobalMessage, {
            configKey: "appName",
            defaultValue: "\u529E\u4E8BAPP"
          })), "\u626B\u63CF\u4E8C\u7EF4\u7801\u5B8C\u6210\u4EBA\u8138\u8BC6\u522B\u3002\u6388\u6743\u5B8C\u6210\u524D\u8BF7\u52FF\u5173\u95ED\u5F39\u7A97\uFF0C", showCountDown(countDown), "\u540E\u6388\u6743\u4FE1\u606F\u5C06\u5931\u6548"),
          customArea: /*#__PURE__*/_react["default"].createElement("div", {
            className: _indexModule["default"].ercodeArea
          }, certifyUrl_ ? /*#__PURE__*/_react["default"].createElement(FacevalidateQR, {
            certifyCode: certifyCode,
            certifyUrl: certifyUrl_
          }) : "")
        });
        break;
      case '1_1':
        context = /*#__PURE__*/_react["default"].createElement(_CommonLayout["default"], {
          title: LOCAL.step1_1.title,
          desc: LOCAL.step1_1.desc,
          customArea: /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              position: 'relative'
            },
            className: _indexModule["default"].ercodeArea
          }, certifyUrl_ ? /*#__PURE__*/_react["default"].createElement(FacevalidateQR, {
            certifyCode: certifyCode,
            certifyUrl: certifyUrl_
          }) : "", /*#__PURE__*/_react["default"].createElement("div", {
            className: _indexModule["default"].ercodeMasker
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _indexModule["default"].faceFailTips
          }, "\u4E8C\u7EF4\u7801\u5DF2\u5931\u6548"), /*#__PURE__*/_react["default"].createElement(_next2.Button, {
            className: _indexModule["default"].faceFailRefresh,
            type: "primary",
            onClick: function onClick() {
              setStep('1');
            }
          }, /*#__PURE__*/_react["default"].createElement("span", null, "\u70B9\u51FB\u5237\u65B0"))))
        });
        break;
      case '2':
        // 展示短信+二维码的显示情况
        // context = <CommonLayout
        //   title={LOCAL.step2.title}
        //   desc={<div className={styles.mainDesc}>方法1 授权短信已发送至对方手机号，请提醒对方尽快完成人脸识别授权。如长时间未收到，您也可以用方法2截图发送二维码，帮助对方完成授权。授权完成前请勿关闭弹窗，{showCountDown(countDown)}后授权信息将失效</div>}
        //   customArea={
        //     <div className={styles.helpArea}>
        //       <CommonLayout
        //         style={{ height: 224, width: 320, background: '#F6F8FB', borderRadius: 4, backgroundColor: '#F6F8FB', padding: '12px 20px' }}
        //         title={LOCAL.step2.tip1Title}
        //         titleClass={styles.title}
        //         desc={<div>{LOCAL.step2.tip1Desc}</div>}
        //         descClass={styles.tip1desc}
        //       />
        //       <CommonLayout
        //         style={{ height: 224, width: 320, background: '#F6F8FB', borderRadius: 4, backgroundColor: '#F6F8FB', padding: '12px 20px' }}
        //         title={LOCAL.step2.tip2Title}
        //         titleClass={styles.title}
        //         desc={LOCAL.step2.tip2Desc}
        //         customArea={<div className={styles.ercodeArea} style={{ marginTop: 8 }}><FacevalidateQR size={120} certifyCode={certifyCode} /></div>}
        //         descClass={styles.tip2desc} />
        //     </div>
        //   } />
        context = /*#__PURE__*/_react["default"].createElement(_CommonLayout["default"], {
          title: LOCAL.step1.title,
          desc: /*#__PURE__*/_react["default"].createElement("div", {
            className: _indexModule["default"].faceDesc
          }, "\u8BF7\u5BF9\u65B9\u5C3D\u5FEB\u8FDB\u884C\u4EBA\u8138\u9A8C\u8BC1\uFF0C\u5B8C\u6210\u6B64\u6B21\u6388\u6743\u3002\u6388\u6743\u65B9\u6CD5\u4E3A\uFF1A\u5BF9\u65B9\u9700\u8981\u4F7F\u7528", /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              color: '#0052FF'
            }
          }, /*#__PURE__*/_react["default"].createElement(GlobalMessage, {
            configKey: "appName",
            defaultValue: "\u529E\u4E8BAPP"
          })), "\u626B\u63CF\u4E0B\u65B9\u7684\u4E8C\u7EF4\u7801\u5B8C\u6210\u4EBA\u8138\u9A8C\u8BC1\u3002", showCountDown(countDown), "\u79D2\u540E\u6388\u6743\u4FE1\u606F\u5C06\u5931\u6548\uFF0C\u5931\u6548\u540E\u8BF7\u91CD\u65B0\u53D1\u8D77\u3002"),
          customArea: /*#__PURE__*/_react["default"].createElement("div", {
            className: _indexModule["default"].ercodeArea,
            style: {
              marginTop: 20
            }
          }, /*#__PURE__*/_react["default"].createElement(FacevalidateQR, {
            certifyCode: certifyCode,
            certifyUrl: certifyUrl_
          }))
        });
        break;
      case '2_1':
        context = /*#__PURE__*/_react["default"].createElement(_CommonLayout["default"], {
          title: /*#__PURE__*/_react["default"].createElement("div", {
            className: _indexModule["default"].helpResult
          }, /*#__PURE__*/_react["default"].createElement("img", {
            style: {
              marginTop: 48
            },
            src: LOCAL.step2_1.src
          }), LOCAL.step2_1.title),
          desc: messageInfo.successInfo,
          descClass: _indexModule["default"].helpdesc,
          customArea: /*#__PURE__*/_react["default"].createElement("div", {
            className: _indexModule["default"].helpButtonArea
          }, /*#__PURE__*/_react["default"].createElement(_next2.Button, {
            type: "primary",
            onClick: function onClick() {
              handleOnCancel(undefined);
            }
          }, "\u7ACB\u5373\u529E\u7406"))
        });
        break;
      case '2_2':
        context = /*#__PURE__*/_react["default"].createElement(_CommonLayout["default"], {
          title: /*#__PURE__*/_react["default"].createElement("div", {
            className: _indexModule["default"].helpResult
          }, /*#__PURE__*/_react["default"].createElement("img", {
            style: {
              marginTop: 48
            },
            src: LOCAL.step2_2.src
          }), LOCAL.step2_2.title),
          desc: LOCAL.step2_2.desc,
          descClass: _indexModule["default"].helpdesc,
          customArea: /*#__PURE__*/_react["default"].createElement("div", {
            className: _indexModule["default"].helpButtonArea
          }, /*#__PURE__*/_react["default"].createElement(_next2.Button, {
            type: "secondary",
            style: {
              marginRight: 12
            },
            onClick: handleOnCancel
          }, "\u53D6\u6D88\u6388\u6743"), /*#__PURE__*/_react["default"].createElement(_next2.Button, {
            type: "primary",
            onClick: function onClick() {
              setStep('2');
            }
          }, "\u518D\u6B21\u6388\u6743"))
        });
        break;
      default:
        context = /*#__PURE__*/_react["default"].createElement("div", null, "\u672A\u5339\u914D:", step_);
        break;
    }
    return context;
  };
  var resultVisible = isQuick ? visible : props.visible;
  var _LOCAL$dialogTitle = LOCAL["step".concat(step)].dialogTitle,
    dialogTitle = _LOCAL$dialogTitle === void 0 ? '选择授权方式' : _LOCAL$dialogTitle;
  return /*#__PURE__*/_react["default"].createElement(_next2.Dialog, {
    visible: resultVisible,
    height: "440px",
    style: {
      width: 700,
      borderRadius: 4
    },
    title: dialogTitle,
    hasMask: true,
    className: _indexModule["default"].commissionDialog,
    footer: false,
    onClose: function onClose(type, e) {
      handleOnCancel(e);
    }
  }, renderContext(step));
}
var CommissionDialog = function CommissionDialog(props, esModule) {
  if (esModule) {
    return /*#__PURE__*/_react["default"].createElement(CommissionContext, props);
  }
  return _reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(CommissionContext, _extends({}, props, {
    isQuick: true
  })), document.createElement('div'));
};
var _default = exports["default"] = CommissionDialog;